import { Util } from '@grandvisionhq/forms';

const isEmailValid = (email)=>email && Util.validations.isEmailAddress(email)
;
const isPostalCodeValid = (country, postalCode)=>country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode)
;
const useValidatePaymentData = ()=>{
    return (paymentData)=>{
        var ref;
        const { email , shippingAddress , paymentMethodData  } = paymentData;
        const billingAddress = (ref = paymentMethodData.info) === null || ref === void 0 ? void 0 : ref.billingAddress;
        if (email && !isEmailValid(email)) {
            return false;
        }
        if ((billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.countryCode) && (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalCode) && !isPostalCodeValid(billingAddress.countryCode, billingAddress.postalCode)) {
            return false;
        }
        if ((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode) && (shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode) && !isPostalCodeValid(shippingAddress.countryCode, shippingAddress.postalCode)) {
            return false;
        }
        return true;
    };
};

export { useValidatePaymentData };
//# sourceMappingURL=use-validate-payment-data.js.map
